import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import Hero from "../components/generic/Hero";
import Overview from "../components/homepage/Overview";
import Countdown from "../components/homepage/Countdown";
import ChinWooInfo from "../components/homepage/ChinWooInfo";
import EventSchedule from "../components/homepage/EventSchedule";
import EventLocation from "../components/homepage/EventLocation";
import SponsorsSection from "../components/homepage/SponsorsSection";
import Contact from "../components/homepage/Contact";

function HomePage() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24">
        <Hero
          className="hero-homepage"
          site_call="homepage"
          next_section="about"
        />
        <Overview />
        <Countdown />
        <ChinWooInfo />
        <EventSchedule />
        <EventLocation />
        <SponsorsSection />
        <Contact />
      </div>
    </TailwindPageWrapper>
  );
}

export default HomePage;
